<div class="container-fluid padMob bg webView" style="padding-left: 25px;padding-right: 20px;">
    <div class="row">
        <div class="col-md-12 col-12 col-sm-12 pad0  padHeder" style="padding-bottom: 0px;display: inherit;padding-right: 36px; padding-left: 18px;">
            
            <div class="col-md-3 col-sm-12 col-12 inLneBlk pad0 lblHeader newHeader">
                <h2 style="font-size: inherit;">{{prTypeID == 1 ? 'Production Jobs' : 'Projects' }}</h2>
                <!-- <h2 style="font-size: 30px;">{{!isFromProjectMod ? 'Production Jobs' : 'Project Jobs' }}</h2> -->
            </div>
            <!-- <span _ngcontent-ktw-c1="" class="redText" style="font-size: 12px; vertical-align: top;margin-left: -50px;">Beta</span> -->
            <div class="col-md-9 col-sm-12 col-12 inLneBlk pad0 txtRight" style="margin-left: 20px;">
                <span class="search">
                    <span class="fa fa-search" style="color: #999; top: 0px !important; font-size: 13px;"></span>
                    <input class="form-control formCtlFltr brdrRadius3" ng-model="search.term" placeholder="Search" matInput
                        (keyup)="applyFilter($event)" #input
                        style="font-size: 13px !important;height: 0px !important; background-color: white !important; text-align: left; height: 0px;display: inline-block; padding-left: 45px !important; padding: 14px 35px !important; padding: {{ProductList.length == 0 ? '14px' :'2px'}};box-shadow: none;width: 35%;"
                        type="text">
                </span>

                <span class="btn btn-orange brdrRadius3"
                    style="padding: 3px 10px ; font-size: 13px; margin-left: 10px; line-height: 1.66em;"
                    [routerLink]="['/XnProduction']" *ngIf="prTypeID == 1">
                    <span style="margin-right: 5px;"><i class="zmdi zmdi-plus"></i></span>
                    <span> Quick Entry</span>
                </span>
                <span class="btn btn-orange brdrRadius3" style="padding: 3px 10px ; font-size: 13px; margin-left: 10px; line-height: 1.66em;"
                    (click)="openEntryModal()" *ngIf="prTypeID == 2">
                    <span style="margin-right: 5px;"><i class="zmdi zmdi-plus"></i></span>
                    <span> Create Project Type </span>
                </span>
                <span class="btn btn-orange brdrRadius3"
                    style="padding: 3px 10px ; font-size: 13px; margin-left: 10px; line-height: 1.66em;"
                    (click)="open(mymodal)">
                    <span style="margin-right: 5px;"><i class="zmdi zmdi-plus"></i></span>
                    <span> {{prTypeID == 1 ? 'Create Job' : 'Create Project'}} </span>
                </span>


                <a class="btn btn-darkBlue brdrRadius3" [routerLink]="['/ProductionReports']" target="{{isWeb ? '_blank' : '_self'}}" style="padding: 3px 8px; font-size: 13px; line-height: 1.66em; 
                margin-left: 10px;" title="Reports" *ngIf="prTypeID == 1 && rights.PrdRpts">
                    <i class="fa fa-line-chart headerIcon" aria-hidden="true" ></i>
                </a>

                <a class="btn btn-darkBlue fntSz brdrRadius3" [routerLink]="['/ProductionSettings']" target="{{isWeb ? '_blank' : '_self'}}"
                    title="Stage Config" style="padding: 3px 10px; font-size: 13px; display: inline-block; line-height: 1.66em; 
                margin-left: 10px;" *ngIf="rights.PrdCfg"><a><i class="fa fa-cog" aria-hidden="true" ></i></a>
                </a>
                <span class="btn btn-darkBlue fntSz brdrRadius3" *ngIf="(ProductList.length > 0) && (isAdmin == true)"
                    (click)="exportToExcelActivities()" title="Export to Excel"
                    style="cursor:pointer;margin-left: 10px;line-height: 1.66em;padding: 3px 10px; font-size: 13px;"><span><i
                            class="fa fa-file-excel-o" aria-hidden="true" ></i></span></span>

            </div>
        </div>

        <div class="col-md-12 col-12 col-sm-12 pad0  padHeder" style="padding: 0px 20px 10px 17px;">
            <div class="row">
                <div class="col-md-12 col-12 col-sm-12 pad0 padHeder"
                    style="padding: 5px 15px;">
                    <span class="label orangeBadge font13 brdrRadius3 bgWhite {{statusID == 1 ? 'activeOrnge' : ''}}" (click)="jobFilter(1)"
                        style="cursor: pointer; margin-left: 0px; border: 1px solid #e88421;padding: 4px 15px !important;"><span>Pending</span></span>
                    <span class="label orangeBadge font13 brdrRadius3 bgWhite {{statusID == 2 ? 'activeOrnge' : ''}}"
                        (click)="jobFilter(2)" style="cursor: pointer; margin-left: 10px; border: 1px solid #e88421;padding: 4px 15px !important;"><span>History</span></span>
                    <div style="display: inline-block;" *ngIf="statusID == 2"> 
                        <label
                            style="margin-left: 10px;margin-right: 5px; font-size: 14px; display: inline-block; margin-bottom:0px; font-weight: normal;"
                            for="sel1">Month : </label>
                    </div>
                    <div style="display: inline-block;" *ngIf="statusID == 2">
                        <select class="form-control formCtlFltr" style="cursor:pointer; background-color: white !important; box-shadow: none;"
                            [(ngModel)]="view.month" tabindex="1" (change)="stockYearChange()">
                            <option [value]="i.id" *ngFor="let i of months;">{{i.display}}</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-8 col-8 col-sm-8 pad0  padHeder" style="padding-top: 10px; padding-bottom: 0;">
                    <div *ngIf="statusID==1">
                        <span class="label darkBlueBadge font13 overFlowHidden brdrRadius3 stats-label" > {{prTypeID == 1 ? 'WIP': 'Ongoing Projects'}}
                            <span style="font-size: 13px !important; font-weight: 600;"> {{WipCnt}} </span>
                        </span>
                        <span class="label darkBlueBadge font13 overFlowHidden brdrRadius3 stats-label" style="margin-right: 10px"> Overdue
                            <span style="font-size: 13px; font-weight: 600;">{{overDueCnt}}</span>
                        </span>
                        <span class="label darkBlueBadge   font13 overFlowHidden brdrRadius3 stats-label" >
                            <span *ngIf="prTypeID == 1">
                                {{TotalJob == 1 ? 'Total Job' : 'Total Jobs'}}
                            </span>
                            <span *ngIf="prTypeID == 2">
                                {{TotalJob == 1 ? 'Total Project' : 'Total Projects'}}
                            </span>
                            <span style="font-size: 13px; font-weight: 600;">{{TotalJob}}</span>
                        </span>
                        <span class="label darkBlueBadge  font13 overFlowHidden brdrRadius3 stats-label" 
                            *ngIf="prTypeID == 1 && oldestJob != ''"> Oldest Job
                            <span style="font-size: 13px; font-weight: 600;">{{oldestJob}}</span>
                        </span>
                        <span class="label darkBlueBadge  font13 elipsis brdrRadius3 stats-label" style="width: 200px;"
                            *ngIf="prTypeID == 1 && maxLoad != ''"> Max Workload @
                            <span style="font-size: 13px; font-weight: 600;">{{maxLoad}}</span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-12 col-12 col-sm-12 " *ngIf="ProductList.length > 0" style="margin-bottom: 10px;">
            <div class="col-md-12 col-12 col-sm-12 pad0 bzMatTbl shadow brdrRadius3">
                <table mat-table [dataSource]="dataSource" matSort style="width: 100%; border-radius: 3px;">
                    <!-- ID Column -->
                    <ng-container matColumnDef="JobNo">
                        <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
                            style="width: 10%;">
                            <label> {{prTypeID == 1 ? 'WIP No.' : 'Project'}} </label>
                        </th>
                        <td mat-cell *matCellDef="let row" (click)="row.JobID ? Edit(row,row.JobID) : ''"  style="{{row.JobID ? 'cursor: pointer;' : ''}} padding: 5px;">
                            {{row.JobNo}} </td>
                    </ng-container>

                    <!-- Progress Column -->
                    <ng-container matColumnDef="ProductName">
                        <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
                            style="width: 15%;">
                            <label> {{prTypeID == 1 ? 'Product' : 'Project Type'}}</label>
                        </th>
                        <td mat-cell *matCellDef="let row" (click)="row.JobID ? Edit(row,row.JobID) : ''" style="{{row.JobID ? 'cursor: pointer;' : ''}} padding: 5px;">
                            {{row.ProductName}} </td>
                    </ng-container>

                    <!-- Name Column -->
                    <ng-container matColumnDef="ProductCode">
                        <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
                            style="width: 10%;">
                            <label>Code</label>
                        </th>
                        <td mat-cell *matCellDef="let row" (click)="row.JobID ? Edit(row,row.JobID) : ''" style="{{row.JobID ? 'cursor: pointer;' : ''}}">
                            <span>{{row.ProductCode}} </span>
                        </td>
                    </ng-container>

                    <!-- Color Column -->
                    <ng-container matColumnDef="CstrRelName">
                        <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
                            style="width: 15%;">
                            <label>Customer</label>
                        </th>
                        <td mat-cell *matCellDef="let row" style="width: 10%;" (click)="row.JobID ? Edit(row,row.JobID) : ''" style="{{row.JobID ? 'cursor: pointer;' : ''}}">
                            <span>{{row.CstrRelName != '' ? row.CstrRelName : '-'}}</span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="LaunchDT">
                        <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
                            style="width: 5%;">
                            <label> Launch </label>
                        </th>
                        <td mat-cell *matCellDef="let row" style="width: 9%; {{row.JobID ? 'cursor: pointer;' : ''}}"
                            (click)="row.JobID ? Edit(row,row.JobID) : ''">{{row.LaunchDT | todayTommorow }} </td>
                    </ng-container>

                    <ng-container matColumnDef="TargetDT">
                        <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
                            style="width: 5%;">
                            <label> Target </label>
                        </th>
                        <td mat-cell *matCellDef="let row" class="txtAlignRgt" style="width: 9%; {{row.JobID ? 'cursor: pointer;' : ''}}"
                            [style.color]="row.TargetDT<today ? '#ff0000' : ''" (click)="row.JobID ? Edit(row,row.JobID) : ''">
                            {{row.TargetDT | todayTommorow}} </td>
                    </ng-container>

                    <ng-container matColumnDef="Qty">
                        <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
                            style="padding-right: 0px; text-align: right; display: flex; justify-content: flex-end; padding-top: 11px">
                            <label style="padding-top: 3px"> Qty </label>
                        </th>
                        <td mat-cell *matCellDef="let row" class="txtAlignRgt"
                            style="padding-right: 15px; text-align: right; width: 5%; {{row.JobID ? 'cursor: pointer;' : ''}}"
                            (click)="row.JobID ? Edit(row,row.JobID) : ''">
                            <!-- {{row.Qty < 0 ? '0' : row.Qty && statusID==2?row.JobQty:'0'}}  -->
                            {{statusID == 2 ? row.JobQty : row.Qty < 0 ? '0' : row.Qty}} </td>
                    </ng-container>

                    <ng-container matColumnDef="SKU">
                        <th class="header header-Table" mat-header-cell *matHeaderCellDef style="width: 5%;">
                            <label> Unit </label>
                        </th>
                        <td mat-cell *matCellDef="let row" style="width: 5%; {{row.JobID ? 'cursor: pointer;' : ''}}"
                            (click)="row.JobID ? Edit(row,row.JobID) : ''"> {{row.SKU}} </td>
                    </ng-container>

                    <ng-container matColumnDef="Stage">
                        <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
                            style="width:8%;">
                            <label *ngIf="statusID == 1"> Stage </label>
                        </th>
                        <td mat-cell *matCellDef="let row" (click)="row.JobID ? Edit(row,row.JobID) : ''" style="vertical-align: middle; padding: 3px 5px 3px 3px; {{row.JobID ? 'cursor: pointer;' : ''}}">
                            <div *ngIf="statusID == 1">
                                <span>{{row.Stage ? row.Stage :
                                    '-'}}</span>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="Action">
                        <th class="header header-Table" mat-header-cell *matHeaderCellDef
                            style="width: 10%;">
                            <label> Action </label>
                        </th>
                        <td mat-cell *matCellDef="let row">
                            <div class="lableBtnOrange inLneBlk brdrRadius3" style="display: inline-block; {{row.JobID ? 'cursor: pointer;' : ''}}"title="View Details" *ngIf="statusID == 1"
                                (click)="row.JobID ? Edit(row,row.JobID) : ''">
                                <i class="fa fa-pencil" aria-hidden="true"></i>
                            </div>
                            <!-- <div class="lableBtnGray inLneBlk" style="border-radius: 50%;margin-left: 10px;">
                        <i class="fa fa-trash" aria-hidden="true"></i>
                      </div> -->
                            <div class="lableBtnDrkBlue brdrRadius3" title="Print" style=" cursor: pointer; display:inline-block; margin-left:10px; padding: 2px 8px;" (click)="row.JobID ? JobCardPrint(row.JobID, row.ItemID) : printTranjection(row.XnID)">
                                <i class="zmdi zmdi-print" aria-hidden="true" style="vertical-align: middle;"></i>
                            </div>
                        </td>
                    </ng-container>
                    

                    <!-- <ng-container matColumnDef="Actions">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> </th>
                    <td mat-cell *matCellDef="let row" style="width: 80px; padding: 0px;">
                    </td>
                    </ng-container> -->


                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr  mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                    <!-- <tr *ngIf="prTypeID == 2" mat-header-row *matHeaderRowDef="displayedProjectColumns"></tr>
                    <tr *ngIf="prTypeID ==2" mat-row *matRowDef="let row; columns: displayedProjectColumns;"></tr> -->

                    <!-- Row shown when there is no matching data. -->
                    <!-- <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="4">No data matching the filter "{{input.value}}"</td>
                </tr> -->

                </table>
                <mat-paginator style="border-radius: 0px 0px 3px 3px;" [pageSizeOptions]="[10, 20, 30]"></mat-paginator>
            </div>
        </div>
    </div>

    <!-- Show cards if Production/Project list count is less than 5 -->
    <div *ngIf="activeProdListCnt <= 5" class="col-md-12 col-sm-12 col-xs-12 pad0" style="margin-top: 10px;">
        <div class="col-md-12 col-sm-12 col-xs-12 pad0 bzSection" style="border-radius: 3px;">
          <div class="col-md-12 col-sm-12 col-xs-12 pad0 noItmMainDiv">
            <!-- Add item manually -->
            <div class="col-md-3 col-sm-3 col-xs-3 pad0 noItmDiv" (click)="open(mymodal)" style="cursor: pointer;">
              <div class="col-md-12 col-sm-12 col-xs-12 pad0 noItmTtl">
                <span>Create a {{ prTypeID == 1 ? 'Production Job' : 'Project' }}</span>
              </div>
              <div class="col-md-12 col-sm-12 col-xs-12 pad0 noItmSbTtl">
                <span>Create a {{ prTypeID == 1 ? 'production job' : 'project' }} so you can track its progress stage-wise.</span>
              </div>
              <span  class="btn orangeButton" 
              style="margin-right: 5px; font-size: 13px !important; color:#fff; border-radius: 3px;">
                <i class="zmdi zmdi-plus" aria-hidden="true" style="position: relative; top: 0px; font-size: 16px"></i>
                <span style="margin-left: 7px;">Create {{ prTypeID == 1 ? 'Job' : 'Project' }}</span>
              </span>
            </div>
            <div *ngIf="rights.InvMstrs" class="col-md-3 col-sm-3 col-xs-3 pad0 noItmDiv" (click)="openEntryModal()" style="cursor: pointer;">
              <div class="col-md-12 col-sm-12 col-xs-12 pad0 noItmTtl">
                <span>Add {{ prTypeID == 1 ? 'a Product' : 'a Project Type' }} </span>
              </div>
              <div class="col-md-12 col-sm-12 col-xs-12 pad0 noItmSbTtl">
                <span>Enter {{ prTypeID == 1 ? 'a product' : 'a project type' }} for which you want to launch a {{ prTypeID == 1 ? 'production job' : 'project' }}.</span>
              </div>
              <span  class="btn orangeButton" 
              style="margin-right: 5px; font-size: 13px !important; color:#fff; border-radius: 3px;">
                <i class="zmdi zmdi-plus" aria-hidden="true" style="position: relative; top: 0px; font-size: 16px"></i>
                <span style="margin-left: 7px;">Add {{ prTypeID == 1 ? 'Product' : 'Project Type' }}</span>
              </span>
            </div>
          </div>
        </div>
      </div>

    <div style="margin: 15px 0px;">
        <div *ngIf="prTypeID == 1">
            <a href="https://biziverse.com/support/support.html?abt=Manufacturing" target="_blank" class="trngDarkBlueBtn" style="padding: 4px 10px; display: inline-block; line-height: 1.66em;">
                <i class="zmdi zmdi-help-outline" style="margin-right: 5px; font-size: 16px; vertical-align: inherit;"></i> Training Materials
            </a>
            <span (click)="openTrngModal()" class="trngDarkBlueBtn" style="margin-left: 10px;">
                <i class="fa fa-youtube-play" style="margin-right: 5px; vertical-align: initial; font-size: 16px;"></i> Watch Training
              </span>
        </div>
        <div *ngIf="prTypeID == 2">
            <span (click)="comingSoon()" class="trngDarkBlueBtn" style="padding: 4px 10px; display: inline-block; line-height: 1.66em;">
                <i class="zmdi zmdi-help-outline" style="margin-right: 5px; font-size: 16px; vertical-align: inherit;"></i> Training Materials
            </span>
        </div>
        <span *ngIf="!showLearningMaterial && showOnBoarding" (click)="openHelpPage(14)" class="trngDarkBlueBtn" style="margin-left: 10px;">
            <i class="fa fa-question" style="margin-right: 5px; vertical-align: initial; font-size: 16px;"></i> Need Help
        </span>
    </div>

</div>

<div class="container-fluid padMob bg mobView" style="padding-right: 0px;">
    <div class="row">
        <div class="pad0 padHeder" style="padding: 15px 15px 10px 15px;display:flex;justify-content: space-between;align-items: center;width:100%;">
            <div class="" style="display: inline-block;padding: 0px;text-shadow: 2px 2px 3px rgb(0 0 0 / 20%);">
                <h4 style="margin:0px;"> {{prTypeID == 1 ? 'Production Jobs' : 'Projects' }}</h4>
            </div>
            <div class="" style="display: flex;align-items: center;gap:10px;margin-right:15px;">
                <a class="darkBlueButton fntSz" [routerLink]="['/ProductionSettings']" target="{{isWeb ? '_blank' : '_self'}}"
                    title="Stage Config" style="padding: 4px 10px; font-size: 14px; display: inline-block;"><a><i class="fa fa-cog" style="vertical-align: text-top;" aria-hidden="true"></i></a>
                </a>
                <span class="btn darkBlueButton brdrRadius3 {{showSearchBar ? 'darkBlueButton-alt' : ''}}" (click)="showSearchBar = !showSearchBar" >
                    <i class="fa fa-search"></i>
                </span>
                <span class="darkBlueButton" 
                        style="" 
                        (click)="backToHomeBtn()">
                            <i class="zmdi zmdi-arrow-left" style="margin-right: 5px;"></i>Back
                </span>
                <!-- <a (click)="backToHomeBtn()" class=" mobViewBtn mobView" target="{{isWeb ? '_blank' : '_self'}}"
                    style="padding: 4px 0px 4px 14px; font-size: 16px; float: right; line-height: 1.66em; margin-right: 7px;display: inline-block;">
                    <i aria-hidden="true" class="fa fa-bars "></i>
                </a> -->

                <!-- <a class="btn btn-yellow" [routerLink]="['/Report']" target="_blank" style="padding: 4px 8px; font-size: 14px; display: inline-block; line-height: 1.66em; 
                margin-left: 10px;float: right;" title="Reports">
                    <i class="fa fa-line-chart headerIcon" aria-hidden="true"></i>
                </a> -->
            </div>
        </div>
        <div class="col-md-12 col-sm-12 col-xs-12" style="margin-bottom: 10px; margin-right: 15px;" *ngIf="showSearchBar">
            <div class="marginT10" style="width: 100%; text-align: right;">
                <div class="search" style="position: relative; width: 100%;">
                    
                    <span class="fa fa-search"
                        style="position: absolute; left: 10px; top: 50%; transform: translateY(-50%); color: #999;">
                    </span>

                    <input class="brdrColor form-control formCtlFltr brdrRadius3"
                        [(ngModel)]="search"
                        type="text"
                        placeholder="Search"
                        style="padding-left: 35px; box-shadow: none; width: 100%; background-color: white;">
                        
                </div>
            </div>
        </div>
        <div class="col-md-12 col-12 col-sm-12 pad0 padHeder mobView" style="display: flex; flex-wrap: wrap; padding: 0px 30px 10px 15px; gap: 10px;">
            <span class="btn btn-orange brdrRadius3"
                style="padding: 3px 10px ; font-size: 13px; line-height: 1.66em;"
                [routerLink]="['/XnProduction']" *ngIf="prTypeID == 1">
                <span style="margin-right: 5px;"><i class="zmdi zmdi-plus"></i></span>
                <span> Quick Entry</span>
            </span>
            <span class="btn btn-orange brdrRadius3"
            style="padding: 3px 10px ; font-size: 13px; line-height: 1.66em;"
            (click)="open(mymodal)">
                <span style="margin-right: 5px;"><i class="zmdi zmdi-plus"></i></span>
                <span> {{prTypeID == 1 ? 'Create Job' : 'Create Project'}} </span>
            </span>
            <span class="btn btn-orange brdrRadius3"
                style="padding: 3px 10px ; font-size: 13px; line-height: 1.66em;"
                (click)="openEntryModal()" *ngIf="prTypeID == 2">
                <span style="margin-right: 5px;"><i class="zmdi zmdi-plus"></i></span>
                <span> Create Project Type </span>
            </span>
        </div>
        <div class="col-md-12 col-12 col-sm-12 pad0 padHeder"
            style="padding: 0px 15px;">
            <span class="label orangeBadge brdrRadius3 orangeBrdr font13 bgWhite {{statusID == 1 ? 'activeOrnge' : '' }}" (click)="jobFilter(1)"
                style="cursor: pointer; margin-left: 0px;"><span>Pending</span></span>

            <span class="label orangeBadge brdrRadius3 brdrRadius3 orangeBrdr font13 bgWhite font13 {{statusID == 2 ? 'activeOrnge' : ''}}" (click)="jobFilter(2)"
                style="cursor: pointer; margin-left: 10px;"><span>History</span></span>
            <div style="display: inline-block;" *ngIf="statusID == 2">
                <label
                    style="margin-left: 10px; font-size: 14px; display: inline-block; margin-bottom:0px; font-weight: normal;"
                    for="sel1">Month : </label>
            </div>
            <div style="display: inline-block;" *ngIf="statusID == 2">
                <select class="form-control formCtlFltr " style="box-shadow: none;" [(ngModel)]="view.month" tabindex="1"
                    (change)="stockYearChange()">
                    <option [value]="i.id" *ngFor="let i of months;">{{i.display}}</option>
                </select>
            </div>
        </div>
        <div class="col-md-12 col-12 col-sm-12 pad0 padHeder" style="padding:10px 15px 10px 15px; display:flex;gap:10px;flex-wrap:wrap;align-items: center;">
            <span class="label darkBlueBadge darkBlueBrdr bgWhite fntSz brdrRadius3 font13" > {{prTypeID == 1 ? 'WIP': 'Ongoing Projects'}}
                <span style="font-size: 13px !important; font-weight: 600;"> {{WipCnt}} </span>
            </span> 
            <span class="label darkBlueBadge darkBlueBrdr bgWhite fntSz brdrRadius3 font13"> Overdue
                <span style="font-size: 13px; font-weight: 600;">{{overDueCnt}}</span>
            </span>
            <span class="label darkBlueBadge darkBlueBrdr bgWhite fntSz brdrRadius3 font13">
                <span *ngIf="prTypeID == 1">
                    {{TotalJob == 1 ? 'Total Job' : 'Total Jobs'}}
                </span>
                <span *ngIf="prTypeID == 2">
                    {{TotalJob == 1 ? 'Total Project' : 'Total Projects'}}
                </span>
                <span style="font-size: 13px; font-weight: 600;">{{TotalJob}}</span>
            </span>
        </div>

        <div class="col-md-12 col-12 col-sm-12 pad0">
            <div class="col-md-12 col-sm-12 col-12 pad0 bgWhite pad15 marginTp font13"
                *ngFor="let x of ProductList | filter:'ProductName,JobNo':search" (click)="Edit(x,x.JobID)">
                <div class="col-md-12 col-12 col-sm-12 pad0">
                    <div class="col-md-8 col-8 col-sm-8 pad0 inLneBlk">
                        <span style="font-weight: bold;">{{x.ProductName}}</span>
                    </div>
                    <div *ngIf="prTypeID == 1" class="col-md-4 col-4 col-sm-4 pad0 inLneBlk txtRight">
                        <span style="color: darkgreen;">{{x.Qty}} {{x.SKU}}</span>
                    </div>
                </div>
                <div class="col-md-12 col-12 col-sm-12 pad0">
                    <div class="col-md-8 col-8 col-sm-8 inLneBlk pad0 font12" >
                        <span style="margin-right: 5px; color: #e88421;"><i class="zmdi zmdi-view-dashboard"></i></span>
                        <span style="color: #777;">{{x.Stage == "" ? "-" : x.Stage}}</span>
                    </div>
                    <div class="col-md-4 col-4 col-sm-4 inLneBlk pad0 txtRight font12">
                        <span style="color: #777;">{{x.TargetDT == "" ? "-" : x.TargetDT | date:'dd-MMM-yy'}}</span>
                    </div>
                </div>
                <div class="col-md-12 col-12 col-sm-12 pad0">
                    <div class="col-md-8 col-8 col-sm-8 inLneBlk pad0 font12">
                        <span style="position: relative; margin-right: 5px;"> <i class="fa fa-user"
                                style="color: #15304A;"></i> </span> <span style="color: #777;">{{ x.CstrRelName == "" ? "-" : x.CstrRelName}}</span>
                    </div>
                    <div class="col-md-4 col-4 col-sm-4 inLneBlk pad0 txtRight font12">
                        <span style="color: #777;">#{{x.JobNo == "" ? "-" : x.JobNo}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Show cards if Production jobs are less than 5 -->
    <div *ngIf="activeProdListCnt <= 5" class="col-md-12 col-sm-12 col-xs-12 pad0" style="margin-top: 10px;">
        <div class="col-md-12 col-sm-12 col-xs-12 pad0 bzSection" style="border-radius: 3px;">
          <div class="col-md-12 col-sm-12 col-xs-12 pad0 noItmMainDiv" style="display: flex; row-gap: 15px;">
            <!-- Add item manually -->
            <div class="col-md-3 col-sm-3 col-xs-3 pad0 noItmDiv" (click)="open(mymodal)">
              <div class="col-md-12 col-sm-12 col-xs-12 pad0 noItmTtl">
                <span>Create a {{ prTypeID == 1 ? 'Production Job' : 'Project' }}</span>
              </div>
              <div class="col-md-12 col-sm-12 col-xs-12 pad0 noItmSbTtl">
                <span>Create a {{ prTypeID == 1 ? 'production job' : 'project' }} so you can track its progress stage-wise.</span>
              </div>
              <span  class="btn orangeButton"
              style="margin-right: 5px; font-size: 13px !important; color:#fff; border-radius: 3px;">
                <i class="zmdi zmdi-plus" aria-hidden="true" style="position: relative; top: 0px; font-size: 16px"></i>
                <span style="margin-left: 7px;">Create {{ prTypeID == 1 ? 'Job' : 'Project' }}</span>
              </span>
            </div>
  
            <div class="col-md-3 col-sm-3 col-xs-3 pad0 noItmDiv" (click)="openEntryModal()">
              <div class="col-md-12 col-sm-12 col-xs-12 pad0 noItmTtl">
                <span>Add {{ prTypeID == 1 ? 'a Product' : 'a Project type' }} </span>
              </div>
              <div class="col-md-12 col-sm-12 col-xs-12 pad0 noItmSbTtl">
                <span>Enter {{ prTypeID == 1 ? 'a product' : 'a project type' }} for which you want to launch a {{ prTypeID == 1 ? 'production job' : 'project' }}.</span>
              </div>
              <span  class="btn orangeButton"
              style="margin-right: 5px; font-size: 13px !important; color:#fff; border-radius: 3px;">
                <i class="zmdi zmdi-plus" aria-hidden="true" style="position: relative; top: 0px; font-size: 16px"></i>
                <span style="margin-left: 7px;">Add {{ prTypeID == 1 ? 'Product' : 'Project Type' }}</span>
              </span>
            </div>
          </div>
        </div>
      </div>

    <div *ngIf="!showLearningMaterial && showOnBoarding" style="margin-top: 15px;">
        <span (click)="openHelpPage(14)" class="trngDarkBlueBtn">
            <i class="fa fa-question" style="margin-right: 5px; vertical-align: initial; font-size: 16px;"></i> Need Help
        </span>
    </div>
</div>

<!--Voucher Entry Modal-->
<ng-template #mymodal let-modal>

    <!--Body-->
    <div class="modal-body" style="padding: 0px;">
        <app-production-job-creation></app-production-job-creation>
    </div>
</ng-template>


<!--Voucher Entry Modal-->
<ng-template #JobDetails let-modal>

    <!--Body-->
    <div class="modal-body" style="padding: 0px;">
        <app-job-details></app-job-details>
    </div>
</ng-template>


<ngx-spinner color="rgb(232, 132, 33)" size="default" type="ball-clip-rotate">

</ngx-spinner>